import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AdminLayout from "./Drawer";
import { formatDate, formatDateTime } from "../comman";
import "./userList.css";

const ScannerList = () => {
    const [events, setEvents] = useState([]);
    const [list, setList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0); // Store total records for pagination
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        fetchEvents();
    }, []);

    // State to hold the events and users data
    const [usersData, setUsersData] = useState([]); // To store merged user data

    const fetchEvents = async () => {
        try {
            const response = await fetch("https://scanner.bharatonline.digital/api/get/scans", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.status === "success") {
                setList(data.data); // Set events data
                // Once events are fetched, fetch users by eventId
                fetchUsersByEventIds(data.data);
            } else {
                console.error("Error in response data:", data);
            }
        } catch (error) {
            console.error("Fetch error:", error.message);
        }
    };
// console.log(list);

    const fetchUsersByEventIds = async (events) => {
        try {
            // Create an array to store all users data
            let allUsers = [];

            // Loop through each event and fetch the users for each eventId
            for (const event of events) {
                const response = await fetch(`/api/get/users?eventId=${event._id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                if (data.status === "success") {
                    // Push the users of the current event into the allUsers array
                    allUsers = [...allUsers, ...data.data]; // Merge user data
                } else {
                    console.error("Error in response data:", data);
                }
            }

            // Set the final merged users data
            setUsersData(allUsers);
        } catch (error) {
            console.error("Fetch error:", error.message);
        }
    };


    const columns = [
        { field: "id", headerName: "Sr.No.", minWidth: 40 , flex: 0.7,},

        // PPP Grouping (Total, Pending, Approved, Rejected)
     
        {
            field: "mobileNumber",
            headerName: "Mobile Number",
            minWidth: 150,
            flex: 0.7,
            cellClassName: "pending-column",
        },
        {
            field: "creation",
            headerName: "Creation Date",
            minWidth: 150,
            flex: 1,
            cellClassName: "approved-column",
        },
    ];
    // console.log(usersData);

 
    const rows =
        list &&
        list?.map((item, index) => ({
            id: index + 1,
            mobileNumber: item?.mobileNumber,
            creation: item?.createdAt && formatDateTime(item.createdAt),
        }));

    return (
        <AdminLayout>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                autoHeight
                slots={{
                    toolbar: GridToolbar,
                    NoRowsOverlay: <>No data found</>,
                }}
                classes={{
                    root: "table-background",
                    // columnHeaders: 'header-background'
                }}
            />

        </AdminLayout>
    );
};

export default ScannerList;
